/**
 * @description UI component to display form label for any input element.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @param {string}  htmlFor id of the input element
 * @param {React.node}  children  any valid react node to be display in label
 * @param {boolean} [required]  to display the tooltip
 * @param {string}  [className] in order to apply any additional styling you can pass the css class.
 *
 * @returns {React.component}
 */

import React from 'react';

import cx from 'classnames';

import styles from './InputLabel.module.scss';

const Label = (props) => {
	const { htmlFor, children, required, className } = props;

	return (
		<label
			htmlFor={htmlFor}
			className={cx(
				styles.labelContainer,
				{
					[styles.labelCursorStylling]: htmlFor,
				},
				className,
			)}
		>
			{children}
			{required ? <span className={styles.required}>*</span> : null}
		</label>
	);
};

export default Label;
